export const postCheckout = async (rateId, noStateCallback) => {
  const inFlowApiUrl = import.meta.env.VITE_IN_FLOW_API_URL;
  const token = window.sessionStorage.getItem("session_token");
  const headers = { Authorization: `Bearer ${token}` };

  if ((!rateId || !token) && noStateCallback) noStateCallback();

  const res = await fetch(`${inFlowApiUrl}/checkout`, {
    method: "POST",
    body: JSON.stringify({ rateID: rateId }),
    headers,
  });
  if (!res.ok) throw new Error(res.status);
  return await res.json();
};
